export const AttendanceStatus = {
    INITIAL: 'INITIAL',
    PRESENT: 'PRESENT',
    ABSENT: 'ABSENT',
    LATE: 'LATE',
    EARLY_LEAVE: 'EARLY_LEAVE',
    EXCUSED: 'EXCUSED',

    getColor(status) {
        switch (status) {
            case this.INITIAL:
                return 'gray';
            case this.PRESENT:
                return 'green';
            case this.ABSENT:
                return 'red';
            case this.LATE:
                return 'orange';
            case this.EARLY_LEAVE:
                return 'yellow';
            case this.EXCUSED:
                return 'blue';
        }
    }
}
